import ApiDataTableContainer from '../../../../Componant/Tables/DataTables/ApiDataTable/ApiDataTable'

const ApiDataTable = () => {
  return (
    <div className='page-body'>
      <ApiDataTableContainer />
    </div>
  )
}

export default ApiDataTable